"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormulaInterpreterError = void 0;
class FormulaInterpreterError {
    constructor(message, error) {
        this.message = message;
        this.name = "FormulaInterpreterError";
        this.stack = error;
    }
}
exports.FormulaInterpreterError = FormulaInterpreterError;
